import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

import type { StudentProfile } from "@shared/types/graphqlGenerated";

const STUDENT_PROFILE_CREATE_MUTATION = gql`
  mutation StudentProfileCreate_Shared_Mutation($input: StudentProfileCreateInput!) {
    studentProfileCreate(input: $input) {
      studentProfile {
        id
        graduationDate
        createdAt
        updatedAt
      }
      errors {
        message
        fields {
          practitionerTypeId
          graduationDate
        }
      }
    }
  }
`;

interface StudentInformationData {
  practitionerTypeId: string;
  graduationDate: string;
}

interface StudentInformationErrors {
  message?: string;
  fields?: {
    practitionerTypeId?: string[];
    graduationDate?: string[];
  };
}

interface StudentProfileCreateData {
  studentProfileCreate: {
    studentProfile: Pick<StudentProfile, "id" | "graduationDate" | "createdAt" | "updatedAt">;
    errors: StudentInformationErrors;
  };
}

interface Variables {
  input: {
    attributes: StudentInformationData;
  };
}

const useStudentProfileCreateMutation = (
  options?: MutationHookOptions<StudentProfileCreateData, Variables>
) => useMutation<StudentProfileCreateData, Variables>(STUDENT_PROFILE_CREATE_MUTATION, options);

export type { StudentProfileCreateData, StudentInformationData, StudentInformationErrors };
export { useStudentProfileCreateMutation, STUDENT_PROFILE_CREATE_MUTATION };
